var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.mostrarSerie,
          expression: "mostrarSerie"
        }
      ],
      attrs: { fluid: "" }
    },
    [
      _c(
        "div",
        { attrs: { align: "left" } },
        [
          _c("v-flex", [
            _c(
              "h2",
              {
                staticClass: "h2_title",
                staticStyle: { "margin-top": "12px !important" }
              },
              [_vm._v("\n        Equipos Seriados\n      ")]
            )
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c(
            "v-layout",
            { staticClass: "ml-5", attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "", sm4: "", md4: "" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Buscar", outlined: "" },
                    on: {
                      keyup: function($event) {
                        return _vm.gridApi.setQuickFilter(_vm.filtro)
                      }
                    },
                    model: {
                      value: _vm.filtro,
                      callback: function($$v) {
                        _vm.filtro = $$v
                      },
                      expression: "filtro"
                    }
                  })
                ],
                1
              ),
              _c("v-flex", { attrs: { xs2: "", sm2: "", md5: "" } }),
              _c("v-flex", { attrs: { xs3: "", sm3: "", md3: "" } }, [
                _c(
                  "div",
                  {
                    staticStyle: { "padding-top": "6px" },
                    attrs: { align: "right" }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticStyle: { "padding-right": "20px" },
                        attrs: { color: "#ffe800" },
                        on: {
                          click: function($event) {
                            return _vm.cargarDispositivosTodos()
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticStyle: { color: "black" },
                            attrs: { dark: "", left: "" }
                          },
                          [_vm._v("add_circle_outline")]
                        ),
                        _c("span", { staticStyle: { color: "black" } }, [
                          _vm._v("Agregar Dispositivos")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "div",
            { staticClass: "tablaSeriadosSelected" },
            [
              _c("AgGridVue", {
                staticClass: "ag-theme-material",
                staticStyle: { "font-family": "'Asap', sans-serif" },
                attrs: { gridOptions: _vm.gridOptions }
              })
            ],
            1
          ),
          _c("TablaSeriesTodos", {
            ref: "TablaSeriesTotales",
            attrs: {
              DispositivosTotales: _vm.DispositivosTotales,
              dataSelected: _vm.dataSelected,
              nuevoCodigo: _vm.nuevoCodigo,
              ubicacionMovimiento: _vm.usuarioActivo.tipoubicaid,
              equipos: _vm.equipos,
              requerimientos: _vm.requerimientos,
              clientes: _vm.clientes,
              idSeriados: _vm.idSeriados
            },
            on: {
              DispositivosTotales: function($event) {
                return _vm.cerrarModal()
              },
              selected: function($event) {
                return _vm.cargarSeriados($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }